export default function IMEIBasedSuccessRateTableHeaderWeekView() {

  function createWeeksThTags(weeks = {}) {
    const weekASC = Object.keys(weeks).sort((a, b) => a.localeCompare(b));
    const weeksThTags = [];

    for (let week of weekASC) {
      weeksThTags.push(
        m("th", { colspan: Object.keys(weeks[week]).length * 4 + 4 }, week)
      );
    }

    return m("tr.text-center.align-middle",
      m("th[scope=col][colspan=2][rowspan=3]", "Client / Week"),
      ...weeksThTags
    );
  }

  return {
    view: (vnode) => {
      return createWeeksThTags(vnode.attrs.weeks)
    }
  }
}